import { useScrollReveal } from '../../../hooks/useScrollReveal';

interface HeroSectionProps {
  onBookCall: () => void;
}

const stats = [
  { value: "300+", label: "Automations Built" },
  { value: "30%", label: "Avg. Lead Increase" },
  { value: "4", label: "Industries Served" },
];

const HeroSection = ({ onBookCall }: HeroSectionProps) => {
  const { ref: badgeRef, visible: badgeVisible } = useScrollReveal(0.1);
  const { ref: headlineRef, visible: headlineVisible } = useScrollReveal(0.1);
  const { ref: subRef, visible: subVisible } = useScrollReveal(0.1);
  const { ref: ctaRef, visible: ctaVisible } = useScrollReveal(0.1);
  const { ref: statsRef, visible: statsVisible } = useScrollReveal(0.1);

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center text-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ff1c3c28302fe7c7c18ecef5b3e1685e.jpg"
          alt="Digital system background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 pt-28 pb-28 flex flex-col items-center">
        {/* Badge */}
        <div
          ref={badgeRef}
          className={`reveal-el ${badgeVisible ? 'is-visible' : ''} inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-10`}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-sapphire animate-pulse"></span>
          <span className="text-xs font-semibold text-white/70 uppercase tracking-widest">AI Automation Agency</span>
        </div>

        {/* Massive headline */}
        <h1
          ref={headlineRef}
          className={`reveal-el stagger-1 ${headlineVisible ? 'is-visible' : ''} text-6xl md:text-7xl lg:text-8xl xl:text-[96px] font-black text-white leading-[1.02] tracking-tight mb-8`}
        >
          Intelligence That<br />
          <span className="text-white/45">Runs Your Business.</span>
        </h1>

        {/* Sub */}
        <p
          ref={subRef}
          className={`reveal-el stagger-2 ${subVisible ? 'is-visible' : ''} text-lg lg:text-xl text-white/55 leading-relaxed max-w-2xl mb-12`}
        >
          We build AI-powered systems that capture, qualify, and convert your leads—so your business operates without gaps.
        </p>

        {/* CTAs */}
        <div
          ref={ctaRef}
          className={`reveal-el stagger-3 ${ctaVisible ? 'is-visible' : ''} flex flex-wrap items-center justify-center gap-4`}
        >
          <button
            onClick={onBookCall}
            className="bg-white hover:bg-white/90 text-[#1d1d1f] text-sm font-bold px-9 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap"
          >
            Book a Strategy Call
          </button>

        </div>

        {/* Stats */}
        <div
          ref={statsRef}
          className={`reveal-el stagger-4 ${statsVisible ? 'is-visible' : ''} flex flex-wrap items-center justify-center gap-14 mt-24 pt-10 border-t border-white/10 w-full`}
        >
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-3xl font-black text-white tracking-tight">{s.value}</div>
              <div className="text-xs text-white/40 mt-1 font-medium">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/30 text-xl"></i>
        </span>
      </div>
    </section>
  );
};

export default HeroSection;
